import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { UserMyRadiant as User, User as UserProject, ApiMyRadiant } from '../../../providers';
import { User as UserAdvance } from '../../../providers/advance_providers';
import { UserPresensi } from '../../presensi/user/user';

@Injectable()
export class Login {

  constructor(
    
    public events: Events,
    public userApi: User,
    public userProject : UserProject,
    public userAdvance : UserAdvance,
    public api : ApiMyRadiant,
    public userPresensi : UserPresensi
  ) {
    
   }

   setSession(){
    let resp = JSON.parse(localStorage.data_user);
    this.userApi.is_login=1;

    this.userApi.data=resp.data;
    this.userApi.hak_akses_modul = resp.modul_akses;

    let akses = {};
    this.userProject.akses = {};
    this.userAdvance.akses = {};
    this.userApi.akses = {};
    this.userPresensi.akses = {};
    resp.akses.forEach(rec => {
      if (rec.modul_id==4) {
        this.setSessionModul(resp,rec,this.userProject);
      }
      if (rec.modul_id==7) {
        this.setSessionModul(resp,rec,this.userAdvance);
        console.log(this.userAdvance);
      }
      if (rec.modul_id == 9) {
        this.setSessionModul(resp,rec,this.userApi);
      }
      if (rec.modul_id == 2) {
        this.setSessionModul(resp,rec,this.userPresensi);
      }
    });
    this.userApi.onesignal_app_id = resp.onesignal_app_id;
    // this.userApi.akses = akses;
    this.events.publish('user:sign_in', resp);     
  }

  setSessionModul(resp_data,response_akses,provider){
    provider.is_login=1;
    provider.data=resp_data.data;
    provider.group = response_akses;
    // provider.onesignal_app_id = resp_data.onesignal_app_id;
    let group_user_data = JSON.parse(response_akses.user_data);
    let akses = provider.akses;
    response_akses.fitur.forEach(rec => {
      akses[rec.fitur_app] = true;
      akses[rec.fitur_app+"_fitur_data"] = rec.fitur_data;
      akses[rec.fitur_app+"_group_data"] = rec.group_data;
      if(rec.group_data=='fitur_user_data' && group_user_data[rec.fitur_app]!=undefined){
          akses[rec.fitur_app+"_user_data"] = group_user_data[rec.fitur_app];
      }
      akses[rec.fitur_app+"_hak_akses_data"] = response_akses.user_data;
    });
    akses = {};
    
    // provider.akses = akses;
    this.events.publish("user:has_set_fitur");
  }

  checkIsLogin() {
    let is_loginProvider = this.userApi.is_login;
    if(localStorage.form_login!=undefined){
      if (is_loginProvider == 0) {
        return 1;
      }else{
        return 2;
      }
    }else{
      return 0;
    }
  } 

  changePassword(params?:any){
    let seq = this.api.post('index.php/myradiant/Profil/changePassword', params);
    return seq;
  }

  getDataLogin(callback:any = "") {  
    if (localStorage.form_login) {      
      let form = JSON.parse(localStorage.form_login);
      let params = form;
  
      this.userApi.login(params).subscribe((resp: any) => {      
        if (resp.success) {
          localStorage.is_login = 1;
          localStorage.form_login = JSON.stringify(form);
          localStorage.data_user = JSON.stringify(resp);
          this.setSession();        
          if (callback && typeof callback == "function") {
            callback(resp);
          }
        }else{
          this.events.publish('user:want_sign_out');
        }
      }, (err) => {      
        localStorage.clear();      
      });
    } else {
      if (callback && typeof callback == "function") {
        callback(null);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/login/login.ts